export default "__VITE_PUBLIC_ASSET__861190af__"